<div class="wrapper">
    <div class="row table-toolbar">
        <div class="cal-xl-4 col-lg-4 col-md-12 col-sm-12">
            <form [formGroup]="AdvancedSearchForm" (ngSubmit)="AdvancedSearchFormSubmit()">
                <div class="row">
                    <div class="">
                        <mat-form-field>
                            <mat-label>User</mat-label>
                            <input type="hidden" formControlName="user_id">
                            <input matInput placeholder="Search" [matAutocomplete]="auto" [formControl]="searchUserNameCtrl" [multiple]="true">
                            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displaySearchUserName" (optionSelected)="onOptionSelected($event)">
                                <mat-option value="al">All Users</mat-option>       
                                    <mat-option *ngFor="let user of usersReport;" [value]="user">
                                    <span>{{user?.name}}</span>
                                </mat-option>
                            </mat-autocomplete>
                            <!-- <mat-error *ngIf="AdvancedSearchForm?.user_id?.errors?.required">This field is required.</mat-error> -->
                        </mat-form-field>

                    </div>
                    <!-- <div class="">
                        <mat-form-field>
                            <mat-label> From Date</mat-label>
                            <input matInput [max]="fromMaxDate" formControlName="from_date" [min]="fromMinDate" (dateInput)="onFromDateChange($event)" [matDatepicker]="leave_from_date" (focus)="leave_from_date.open()">
                            <mat-datepicker-toggle matSuffix [for]="leave_from_date"></mat-datepicker-toggle>
                            <mat-datepicker #leave_from_date></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="">
                        <mat-form-field>
                            <mat-label> To Date</mat-label>
                            <input matInput [max]="toMaxDate" formControlName="to_date" [min]="toMinDate" (dateInput)="onToDateChange($event)" [matDatepicker]="leave_to_date" (focus)="leave_to_date.open()">
                            <mat-datepicker-toggle matSuffix [for]="leave_to_date"></mat-datepicker-toggle>
                            <mat-datepicker #leave_to_date></mat-datepicker>
                        </mat-form-field>
                    </div> -->
                    
                    <div class="">
                        <div class="button-group">

                        <button type="submit" mat-raised-button class="btn-int-blue forSearch">Search </button>
                    </div>
                </div>
                   
                </div>
            </form>
        </div>
        <div class="cal-xl-6 col-lg-6 col-md-12 col-sm-12">
            <mat-paginator #paginator [length]="page_length" [pageSize]="items_per_page" [pageSizeOptions]="PAGE_SIZE_OPTIONS_DATA" (page)="handlePage($event)"></mat-paginator>
        </div>
        <div class="cal-xl-2 col-lg-2 col-md-12 col-sm-12">
            <div class="button-group">
                <button type="button" (click)="createWfh()" class="btn-int-blue" mat-raised-button>Apply WFH</button>
            </div>

        </div>
    </div>
    <div class="row">
        <div class="cal-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="mat-table-responsive">
                <table mat-table [dataSource]="wfhDataSource">

                    <ng-container matColumnDef="user_name">
                        <th mat-header-cell *matHeaderCellDef>Employee Name </th>
                        <td mat-cell *matCellDef="let element"> {{(element.user_name != null)? element.user_name :" - "}} </td>
                    </ng-container>

                    <ng-container matColumnDef="wfh_from">
                        <th mat-header-cell *matHeaderCellDef> WFH From </th>
                        <td mat-cell *matCellDef="let element"> {{element.wfh_from}} </td>
                    </ng-container>
                    <ng-container matColumnDef="wfh_to">
                        <th mat-header-cell *matHeaderCellDef> WFH To </th>
                        <td mat-cell *matCellDef="let element"> {{element.wfh_to}} </td>
                    </ng-container>
                    <ng-container matColumnDef="wfh_reason">
                        <th mat-header-cell *matHeaderCellDef>Reason </th>
                        <td mat-cell *matCellDef="let element"> {{element.wfh_reason}} </td>
                    </ng-container>
                    <ng-container matColumnDef="wfh_days">
                        <th mat-header-cell *matHeaderCellDef> WFH Days </th>
                        <td mat-cell *matCellDef="let element"> {{element.wfh_days}} </td>
                    </ng-container>
                    <ng-container matColumnDef="wfh_status">
                        <th mat-header-cell *matHeaderCellDef>Status</th>
                        <td mat-cell *matCellDef="let element">
                            <!-- Check if the user is an admin -->
                            <ng-container *ngIf="isAdmin(); else conditionalButtons">
                                <!-- Admins can always see the buttons -->
                                <ng-container *ngIf="element.wfh_status == 0">
                                    <button mat-raised-button color="primary" style="margin-right: 10px;" (click)="updateStatus(element.id, '1')">Approve</button>
                                    <button mat-raised-button color="warn" style="margin-right: 10px;" (click)="updateStatus(element.id, '2')">Reject</button>
                                </ng-container>
                                <!-- Show other statuses for admins -->
                                <ng-container *ngIf="element.wfh_status == 1">
                                    <span>Approved</span>
                                </ng-container>
                                <ng-container *ngIf="element.wfh_status == 2">
                                    <span>Rejected</span>
                                </ng-container>
                                <ng-container *ngIf="element.wfh_status == 3">
                                    <span>Cancelled</span>
                                </ng-container>
                            </ng-container>
                        
                            <!-- Conditional buttons and status for non-admins -->
                            <ng-template #conditionalButtons>
                                <!-- Check if user_id matches report_to_id -->
                                <ng-container *ngIf="user_details?.user_id === element.applied_to_id; else showApplied">
                                    <!-- Show buttons for non-admins if user_id matches report_to_id -->
                                    <ng-container *ngIf="element.wfh_status == 0">
                                        <button mat-raised-button color="primary" style="margin-right: 10px;" (click)="updateStatus(element.id, '1')">Approve</button>
                                        <button mat-raised-button color="warn" style="margin-right: 10px;" (click)="updateStatus(element.id, '2')">Reject</button>
                                    </ng-container>
                                    <!-- Show status text if status is not 0 -->
                                    <ng-container *ngIf="element.wfh_status == 1">
                                        <span>Approved</span>
                                    </ng-container>
                                    <ng-container *ngIf="element.wfh_status == 2">
                                        <span>Rejected</span>
                                    </ng-container>
                                    <ng-container *ngIf="element.wfh_status == 3">
                                        <span>Cancelled</span>
                                    </ng-container>
                                </ng-container>
                            </ng-template>
                        
                            <!-- Show "Applied" if no buttons are displayed -->
                            <ng-template #showApplied>
                                <ng-container *ngIf="element.wfh_status == 0">
                                    <span>Applied</span>
                                </ng-container>
                                <ng-container *ngIf="element.wfh_status == 1">
                                    <span>Approved</span>
                                </ng-container>
                                <ng-container *ngIf="element.wfh_status == 2">
                                    <span>Rejected</span>
                                </ng-container>
                                <ng-container *ngIf="element.wfh_status == 3">
                                    <span>Cancelled</span>
                                </ng-container>
                            </ng-template>
                        </td>
                                                
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns | tableShowColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns | tableShowColumns;"></tr>
                </table>
                <ng-container *ngIf="wfhDataSource?.filteredData?.length == 0">
                    <div class="row forNoRecords">
                        <h3 class="table-no-date"> No Record found</h3>
                    </div>
                </ng-container>
                <app-table-loader></app-table-loader>

            </div>

        </div>
    </div>
</div>